// Import the functions you need from the SDKs you need

// import { initializeApp } from "firebase/app";
import firebase from "firebase/compat/app";

import "firebase/compat/firestore";

import { getAuth } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyAqbHiUqKFblZ6929XU33h4erI0DD1c_4s",
  authDomain: "beyown-19fb6.firebaseapp.com",
  databaseURL: "https://beyown-19fb6-default-rtdb.firebaseio.com",
  projectId: "beyown-19fb6",
  storageBucket: "beyown-19fb6.firebasestorage.app",
  messagingSenderId: "960894969461",
  appId: "1:960894969461:web:3ad3ffdbcbcbc11e763a3c",
  measurementId: "G-XWF8XPBZFR",
};

// Initialize Firebase

const app = firebase.initializeApp(firebaseConfig);
export default firebase;
// const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
// export const firebaseAnalytics = firebase.analytics();
